// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__134Ql","wrapper":"styles_wrapper__1sgkk","title":"styles_title__2irBQ"};